import { useChatInputStore } from '@/store';

/**
 * Read the live composer text for a chat context.
 * Mirrors ChatInput's `conversationId || 'new'` keying so suggestion
 * components always see the same text the user is typing.
 */
export function useComposerText(contextId) {
  return useChatInputStore((state) => {
    const key = contextId != null && contextId !== ''
      ? contextId
      : (state.currentContextId || 'new');
    return state.inputStates[key]?.text ?? '';
  });
}

export default useComposerText;
